

















import { Component, Prop, Vue } from 'vue-property-decorator';

interface filterConfig {
    param: any;
    isValid: boolean;
}

@Component
export default class OperatorFilterPulldown extends Vue {
    @Prop() private discription!: string;
    @Prop() private filterConfigs!: filterConfig[];

    private allSelected: boolean = true;

    private allChange() {
        if (this.allSelected) {
            this.filterConfigs.map((filterConfig) => filterConfig.isValid = true);
        } else {
            this.filterConfigs.map((filterConfig) => filterConfig.isValid = false);
        }
    }

    private eachChanged() {
        const unselected = this.filterConfigs.filter((filterConfig) => !filterConfig.isValid);
        this.allSelected = (unselected.length === 0) ? true : false;
    }
}
